export default __webpack_public_path__ + "apple-touch-icon.45d486bf.png";